export default __webpack_public_path__ + "static/media/0xaa9e582e5751d703f85912903bacaddfed26484c.d32ebed9.svg";